import $ from 'jquery';
import React from 'react';
import ReactModal from 'react-modal';
import { string } from 'prop-types';
import createHistory from 'history/createBrowserHistory';
import { getQueryParams } from 'utils/query-param-helpers';
import { attachEnterAsClickDecorator } from 'utils/attachEnterAsClick';
import Icon from 'components/icon';
import scrollTo from 'utils/scroll-to';
import Loader from '../loader';
import {
    initActiveFilters,
    manageActiveFilters,
    removeActiveFilterGroup,
    getActiveFiltersWithValues
} from './utils/active-filters';
import { parseQueryString, buildQueryString } from './utils/query-string';
import FiltersLayout from './layouts/FiltersLayout';
import ListingItemsLayout from './layouts/ListingItemsLayout';
import ActiveFiltersLayout from './layouts/ActiveFiltersLayout';
import ModalHelper from './modal/modalHelpers';
import { filterItems, paginateItems, sortItems } from './utils/item-filter';

export default class FilteredListing extends React.Component {
    constructor(props) {
        super(props);

        ReactModal.setAppElement('.listing-app');
        this.history = createHistory();
        this.state = {
            isLoading: true,
            data: {
                filterOptions: [],
                contentData: [],
                resources: [],
                settings: {}
            },
            APIStatus: '',
            APIMessage: '',
            showModal: false,
            modalDataItems: null,
            modalType: '',
            activeFilters: [],
            currentSort: 'default',
            currentPage: 0, // page 1 is 0 (array index value)
            menuActive: false
        };

        this.toggleFilters = this.toggleFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.resetFilterGroup = this.resetFilterGroup.bind(this);
        this.changePage = this.changePage.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.toggleFocus = this.toggleFocus.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleToggleMenu = this.handleToggleMenu.bind(this);
        this.clearKeywordInputValue = this.clearKeywordInputValue.bind(this);
    }

    componentDidMount() {
        const newState = { ...this.state };

        // If the app is still loading then get data from API
        if (this.state.isLoading) {
            // fetch data from API endpoint
            this.fetchItems(this.props.url, newState);
        }
        const loadingEl = document.querySelector('.c-loader');
        if (loadingEl) {
            loadingEl.style.cssText = 'display:none';
        }
    }

    componentDidUpdate() {
        if (document.getElementById('active-filter-reset')) {
            document.getElementById('active-filter-reset').style.cssText =
                'opacity: 1; pointerEvents: all';
        }
        const resultEl = Array.from(document.querySelectorAll('.tile-content'));
        const loadingEl = document.querySelector('.c-loader');
        if (resultEl) {
            resultEl.forEach(e => {
                e.style.cssText = '';
                if (e.querySelector('.tile-cta')) {
                    e.querySelector('.tile-cta').style.cssText =
                        'display: block';
                }
            });
        }
        if (loadingEl) {
            loadingEl.style.cssText = 'display: none';
        }
    }

    setData(data, newState) {
        // set results & settings
        newState.data.contentData = data.contentData;
        newState.data.settings = data.settings;

        // set filters if they exist
        if (data.filterOptions && data.filterOptions.length) {
            newState.data.filterOptions = data.filterOptions;
        }

        // set resources if they exist
        if (data.resources && data.resources.length) {
            newState.data.resources = data.resources;
        }

        if (data.sortByDefault) {
            newState.currentSort = data.sortByDefault;
        }
    }

    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillUpdate(newProps, newState) {
        const queryParams = buildQueryString(newState);
        this.history.replace({
            pathname: window.location.pathname,
            search: queryParams
        });

        if (newState.currentPage !== this.state.currentPage) {
            scrollTo(document.body, 0, 200);
        }
    }

    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillMount() {
        const newState = { ...this.state };
        const pageData = this.props.rawData.trim();

        // check for JSON data on the page,
        // If it exists then we're getting data from local mock json file
        if (pageData && pageData.length) {
            // convert the page contents to JSON format & set to state
            const jsonPageData = $.parseJSON(pageData);

            setTimeout(this.setData(jsonPageData, newState), 10);

            // hide the loader if we have items from mock JSON page data
            if (
                jsonPageData.contentData &&
                jsonPageData.contentData.length > 0
            ) {
                newState.isLoading = false;
            }

            newState.activeFilters = initActiveFilters(
                jsonPageData.filterOptions
            );

            this.prePopulateFilters(newState);

            // update the app state with new preset filter values
            this.setState(...this.state, newState);
        }
    }

    handleCloseModal() {
        this.setState({ showModal: false, modalDataItems: null });
    }

    handleOpenModal(modalDataItems, type) {
        this.setState({
            showModal: true,
            modalType: type,
            modalDataItems
        });
    }

    prePopulateFilters(newState) {
        const url = getQueryParams();
        const activeFilters =
            this.state.activeFilters.length > 0 ||
            initActiveFilters(this.state.data.filterOptions);
        const presetFilters = parseQueryString(
            url,
            activeFilters,
            this.state.currentPage
        );

        if (presetFilters) {
            if (
                JSON.stringify(presetFilters.activeFilters) !==
                JSON.stringify(this.state.activeFilters)
            ) {
                newState.activeFilters = presetFilters.activeFilters;
            }

            if (presetFilters.currentSort !== newState.currentSort) {
                newState.currentSort = presetFilters.currentSort;
            }

            if (parseInt(presetFilters.currentPage, 10) !== 0) {
                newState.currentPage = parseInt(presetFilters.currentPage, 10);
            }
            if (presetFilters.modal && presetFilters.modalID) {
                const modalID = decodeURIComponent(presetFilters.modalID);
                const modalItem = this.state.data.contentData.filter(
                    i => i.guid === modalID
                );
                newState.modalDataItems = modalItem[0]; // eslint-disable-line prefer-destructuring
            }
        }
    }

    fetchItems(url, newState) {
        $.getJSON(`/api/${url}`)
            .fail((jqxhr, textStatus, error) => {
                newState.APIStatus = 'error';
                newState.APIMessage = `${textStatus}, ${error}`;
                // update the app state with api error values
                this.setState(...this.state, newState);
            })
            .done(response => {
                setTimeout(this.setData(response.data, newState), 10);

                newState.isLoading = false;

                newState.activeFilters = initActiveFilters(
                    response.data.filterOptions
                );
                const populateFiltersP = Promise.resolve(
                    this.prePopulateFilters(newState)
                );
                populateFiltersP.then(() => {
                    if (newState.modalDataItems) {
                        this.handleOpenModal(
                            newState.modalDataItems,
                            'location'
                        );
                    }
                });

                // update the app state with api data & new preset filter values
                this.setState(...this.state, newState);
            });
    }

    checkBrowser() {
        const uA = window.navigator.userAgent;
        const onlyIEorEdge =
            /msie\s|trident\/|edge\//i.test(uA) &&
            !!(document.uniqueID || window.MSInputMethodContext);
        const checkVersion =
            (onlyIEorEdge && +/(edge\/|rv:|msie\s)([\d.]+)/i.exec(uA)[2]) ||
            null;

        return checkVersion;
    }

    resetFilters(event) {
        event.currentTarget.style.cssText = `opacity: ${this.props.fadeOpacity}; pointerEvents: none`;
        event.preventDefault();
        const resultEl = Array.from(document.querySelectorAll('.tile-content'));
        const loadingEl = document.querySelector('.c-loader');
        if (loadingEl) {
            loadingEl.style.cssText = 'display: block';
        }
        if (resultEl) {
            resultEl.forEach(e => {
                e.style.cssText =
                    'color: transparent; text-shadow: 0 0 10px rgba(0,0,0,0.5)';
                if (e.querySelector('.tile-cta')) {
                    e.querySelector('.tile-cta').style.cssText =
                        'display: none';
                }
            });
        }
        setTimeout(() => {
            this.setState({
                activeFilters: initActiveFilters(this.state.data.filterOptions),
                currentPage: 0
            });
        }, 10);
    }

    resetFilterGroup(groupCode) {
        const resultEl = Array.from(document.querySelectorAll('.tile-content'));
        const loadingEl = document.querySelector('.c-loader');
        if (loadingEl) {
            loadingEl.style.cssText = 'display: block';
        }
        if (resultEl) {
            resultEl.forEach(e => {
                e.style.cssText =
                    'color: transparent; text-shadow: 0 0 10px rgba(0,0,0,0.5)';
                if (e.querySelector('.tile-cta')) {
                    e.querySelector('.tile-cta').style.cssText =
                        'display: none';
                }
            });
        }

        setTimeout(() => {
            this.setState({
                activeFilters: removeActiveFilterGroup(
                    this.state.activeFilters,
                    groupCode
                ),
                currentPage: 0
            });
        }, 10);
    }

    toggleFilters(evt, filter, value, forceClear = false) {
        this.setState({
            activeFilters: manageActiveFilters(
                this.state.activeFilters,
                filter.code,
                value,
                forceClear
            ),
            currentPage: 0
        });
    }

    clearKeywordInputValue(groupCode) {
        this.setState({
            activeFilters: manageActiveFilters(
                this.state.activeFilters,
                groupCode.code,
                ''
            ),
            currentPage: 0
        });
    }

    changePage(pageNum) {
        this.setState({ currentPage: pageNum });
    }

    updateSort(sort) {
        this.setState({
            currentSort: sort,
            currentPage: 0
        });
    }

    toggleFocus(filter) {
        this.setState({ focusedFilter: filter ? filter.code : null });
    }

    handleToggleMenu(e) {
        e.preventDefault();
        this.setState({ menuActive: !this.state.menuActive });
    }

    renderAPIErrorMessage() {
        if (this.state.APIStatus !== 'error') {
            return null;
        }

        return (
            <p className="validation-msg">
                Oops, something went wrong: {this.state.APIMessage}
            </p>
        );
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div>
                    <Loader />
                    {this.renderAPIErrorMessage}
                </div>
            );
        }

        const {
            contentData,
            filterOptions,
            resources,
            settings
        } = this.state.data;
        const {
            filtersLayout,
            itemContainerLayout,
            itemDirection,
            itemType
        } = this.props;
        const filterSettingsObj = {
            activeFiltersStyle: settings.activeFiltersStyle
                ? settings.activeFiltersStyle
                : 'btn-tags',
            showActiveFilters: settings.showActiveFilters,
            activeFiltersLabel: settings.activeFiltersLabel,
            keywordPlaceholderText: settings.keywordPlaceholderText,
            keywordSearchableFields: settings.keywordSearchableFields,
            excludedSearchAttr: settings.excludedSearchAttr
        };
        const filterCount = this.checkBrowser()
            ? false
            : !!settings.filterCount;
        const activeFilters = getActiveFiltersWithValues(
            this.state.activeFilters
        );
        const filteredItems = filterItems(
            activeFilters,
            contentData,
            filterSettingsObj.keywordSearchableFields,
            filterSettingsObj.excludedSearchAttr
        );
        const sortedItems = sortItems(
            filteredItems,
            settings.defaultSort ? settings.defaultSort : this.state.currentSort
        );
        const pagedItems = paginateItems(
            sortedItems,
            this.state.currentPage,
            settings.itemsPerPage
        );

        const componentTitleText =
            settings.labels && settings.labels.componentTitle
                ? settings.labels.componentTitle
                : 'Product Finder';
        const viewMoreText =
            settings.labels && settings.labels.viewMore
                ? settings.labels.viewMore
                : 'view more';
        const backText =
            settings.labels && settings.labels.back
                ? settings.labels.back
                : 'back';
        const meetUsText =
            settings.labels && settings.labels.meetUs
                ? settings.labels.meetUs
                : 'meet us';
        const getDirectionsText =
            settings.labels && settings.labels.getDirections
                ? settings.labels.getDirections
                : 'get directions';
        const localHoursText =
            settings.labels && settings.labels.localHours
                ? settings.labels.localHours
                : 'local hours';
        const downloadText =
            settings.labels && settings.labels.dataItemButtonText
                ? settings.labels.dataItemButtonText
                : 'download brochure';
        const viewProductText =
            settings.labels && settings.labels.dataItemButtonText
                ? settings.labels.dataItemButtonText
                : 'view product details';
        const noItemsText =
            settings.labels && settings.labels.noDataRemoveFilter
                ? settings.labels.noDataRemoveFilter
                : 'Remove All Filters';
        const countLabel =
            settings.labels && settings.labels.countLabel
                ? settings.labels.countLabel
                : 'Products';
        const noDataMessage =
            settings.labels && settings.labels.noDataMessage
                ? settings.labels.noDataMessage
                : 'We are sorry, no matching items were found';
        const noDataButtonText =
            settings.labels && settings.labels.noDataButtonText
                ? settings.labels.noDataButtonText
                : 'Contact Us';
        const noDataButtonUrl =
            settings.labels && settings.labels.noDataButtonUrl
                ? settings.labels.noDataButtonUrl
                : '/en/contact-us';
        const columnName1 =
            settings.labels && settings.labels.columnName1
                ? settings.labels.columnName1
                : '';
        const columnName2 =
            settings.labels && settings.labels.columnName2
                ? settings.labels.columnName2
                : '';
        const columnName3 =
            settings.labels && settings.labels.columnName3
                ? settings.labels.columnName3
                : '';
        const isProductFinder = itemType === 'ProductListingTile';

        return (
            <div className={`c-filtered-listing ${filtersLayout}`}>
                <div className="filtered-listing-container">
                    <div className="filtered-listing">
                        {filtersLayout === 'filters-side' ? (
                            <button
                                className={`filters-trigger ${
                                    this.state.menuActive ? 'menu-open' : ''
                                } `}
                                onClick={this.handleToggleMenu}
                            >
                                {this.state.menuActive ? 'Close' : 'Filter'}
                                {this.state.menuActive ? (
                                    <Icon glyph="cross" />
                                ) : (
                                    <Icon glyph="filter" />
                                )}
                            </button>
                        ) : null}
                        {isProductFinder && (
                            <ActiveFiltersLayout
                                activeFilters={activeFilters}
                                toggleFilters={attachEnterAsClickDecorator(
                                    this.toggleFilters
                                )}
                                resetFilters={this.resetFilters}
                                clearKeywordInputValue={
                                    this.clearKeywordInputValue
                                }
                                componentTitleText={componentTitleText}
                            />
                        )}
                        <FiltersLayout
                            filters={filterOptions}
                            activeFilters={activeFilters}
                            filterSettings={filterSettingsObj}
                            noDataButtonText={noDataButtonText}
                            toggleFilters={attachEnterAsClickDecorator(
                                this.toggleFilters
                            )}
                            resetFilters={this.resetFilters}
                            resetFilterGroup={this.resetFilterGroup}
                            focusedFilter={this.state.focusedFilter}
                            toggleFocus={this.toggleFocus}
                            filtersLayout={filtersLayout}
                            menuActive={this.state.menuActive}
                            handleToggleMenu={this.handleToggleMenu}
                            filteredItems={filteredItems}
                            contentData={contentData}
                            filterCount={filterCount}
                            noItemsText={noItemsText}
                            fadeOpacity={this.props.fadeOpacity}
                            isProductFinder={isProductFinder}
                        />
                        <ListingItemsLayout
                            itemWrapperModifier={itemContainerLayout}
                            itemType={itemType}
                            itemDirection={itemDirection}
                            listingItems={pagedItems}
                            resources={resources}
                            handleOpenModal={this.handleOpenModal}
                            showResultCount={settings.showResultCount}
                            itemCount={filteredItems.length}
                            countLabel={countLabel}
                            sortBy={settings.sortBy}
                            currentSort={this.state.currentSort}
                            updateSort={this.updateSort}
                            totalPages={Math.ceil(
                                filteredItems.length / settings.itemsPerPage
                            )}
                            itemsPerPage={settings.itemsPerPage}
                            currentPage={this.state.currentPage}
                            changePage={this.changePage}
                            resetFilters={this.resetFilters}
                            viewMoreText={viewMoreText}
                            backText={backText}
                            meetUsText={meetUsText}
                            downloadText={downloadText}
                            viewProductText={viewProductText}
                            noDataMessage={noDataMessage}
                            noDataButtonText={noDataButtonText}
                            noDataButtonUrl={noDataButtonUrl}
                            noItemsText={noItemsText}
                            columnName1={columnName1}
                            columnName2={columnName2}
                            columnName3={columnName3}
                            keywordFilter={filterOptions[0]}
                            activeFilters={activeFilters}
                            toggleFilters={attachEnterAsClickDecorator(
                                this.toggleFilters
                            )}
                            keywordPlaceholderText={
                                filterSettingsObj.keywordPlaceholderText
                            }
                            isProductFinder={isProductFinder}
                        />
                        <ReactModal
                            isOpen={this.state.showModal}
                            contentLabel="react-modal"
                            className="react-modal"
                            overlayClassName="react-overlay"
                            onRequestClose={() => {
                                this.handleCloseModal();
                            }}
                        >
                            <div className="prompt-container">
                                <div className="btn-wrapper">
                                    <button
                                        onClick={this.handleCloseModal}
                                        className="btn-skin-3"
                                    >
                                        <Icon glyph="chevron-left" />
                                        <span>
                                            {backText ? backText : 'close'}
                                        </span>
                                    </button>
                                </div>
                                <div className="modalData">
                                    <ModalHelper
                                        modalDataItems={
                                            this.state.modalDataItems
                                        }
                                        modalType={this.state.modalType}
                                        getDirectionsText={getDirectionsText}
                                        localHoursText={localHoursText}
                                    />
                                </div>
                            </div>
                        </ReactModal>
                    </div>
                </div>
            </div>
        );
    }
}

FilteredListing.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    url: string,
    rawData: string,
    itemType: string,
    itemDirection: string,
    itemContainerLayout: string,
    filtersLayout: string,
    fadeOpacity: string
    /* eslint-enable react/no-typos */
};

FilteredListing.defaultProps = {
    url: '',
    rawData: '',
    itemType: 'content',
    itemDirection: 'vertical',
    itemContainerLayout: 'four-col',
    filtersLayout: 'filters-top',
    fadeOpacity: '0.2'
};
